import { createAsyncThunk, AsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from './store';
import { Error } from 'components/app/_helpers/app-errors.helper';
import { ReduxError } from './store';

type API = {
  dispatch: AppDispatch;
  getState: () => RootState;
  rejectWithValue: (value: unknown) => unknown;
};

export const createSafeAsyncThunk = <Returned, Arg = void>(
  typePrefix: string,
  payloadCreator: (arg: Arg, api: API) => Promise<Returned>
): AsyncThunk<Returned, Arg, { dispatch: AppDispatch; state: RootState }> => {
  return createAsyncThunk<Returned, Arg, { dispatch: AppDispatch; state: RootState }>(
    typePrefix,
    async (arg, thunkAPI) => {
      try {
        return await payloadCreator(arg, {
          dispatch: thunkAPI.dispatch,
          getState: thunkAPI.getState,
          rejectWithValue: thunkAPI.rejectWithValue,
        });
      } catch (error) {
        return thunkAPI.rejectWithValue(Error.reduxErrorHandler(error as ReduxError));
      }
    }
  );
};
